import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../utils/motion';
const models = [{
  name: 'CJI',
  fullName: 'Civic Judgment Index',
  body: 'The foundational assessment approach for reasoning and judgment: how people evaluate claims, think through consequences, and resist manipulation.',
  href: '/cji',
  linkLabel: 'Explore CJI'
}, {
  name: 'NCJI',
  fullName: 'Neurocognitive Civic Judgment Index',
  body: 'Extends CJI into development pathways, reassessment, and opportunity alignment across the lifecycle, from early learning to leadership.',
  href: '/ncji',
  linkLabel: 'Explore NCJI'
}];
export function HumanCapabilityModels() {
  return <section id="cji-ncji" aria-labelledby="cji-ncji-title" className="scroll-mt-20 bg-white border-t border-line py-20 lg:py-24" data-id="element-557" data-mp="21kxhw83m0wc8">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-558" data-mp="77o3c1w7ikn4">
        <div className="lg:col-span-5" data-id="element-559" data-mp="3f26lbhcuqrg9">
          <h2 id="cji-ncji-title" className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight mb-5" data-id="element-560" data-mp="3a9vjg8yjwvl2">
            CJI and NCJI
          </h2>
          <p className="text-lg text-ink-muted leading-relaxed" data-id="element-561" data-mp="319qqh3u3tzqf">
            The framework includes two assessment models. CJI is the foundation;
            NCJI builds on it.
          </p>
        </div>
        <ul className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-x-10 border-t border-line" data-id="element-562" data-mp="3szv48jnczoio">
          {models.map(model => <li key={model.name} className="flex flex-col pt-6 pb-2" data-id="element-563" data-mp="3ox8dyn6c6bnl">
              <h3 className="font-heading font-bold text-2xl text-ink-dark" data-id="element-564" data-mp="3jyn9gbk1x5tc">{model.name}</h3>
              <p className="text-sm font-medium text-teal mb-3" data-id="element-565" data-mp="2djwdmm9scb66">{model.fullName}</p>
              <p className="text-lg text-ink-dark leading-relaxed mb-5" data-id="element-566" data-mp="28ktbb9l6wj1w">{model.body}</p>
              <a href={model.href} className="mt-auto inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-567" data-mp="2a1p3vaz3yqjm">
                {model.linkLabel}
                <ArrowRight size={16} aria-hidden="true" data-id="element-568" data-mp="254oxeyycjlrz" />
              </a>
            </li>)}
        </ul>
      </motion.div>
    </section>;
}